import { StringDecoder } from 'node:string_decoder';

/**
 * Accumulates raw output chunks up to `maxBytes` — measured in bytes, not
 * UTF-16 code units — and decodes once at the end, so a multi-byte UTF-8
 * sequence split across stream chunks (or cut by the cap) never surfaces as
 * replacement characters.
 */
export class CappedOutputSink {
  #chunks: Buffer[] = [];

  #bytes = 0;

  #maxBytes: number;

  truncated = false;

  constructor(maxBytes: number) {
    this.#maxBytes = maxBytes;
  }

  push(chunk: Buffer): void {
    const remaining = this.#maxBytes - this.#bytes;
    if (remaining <= 0) {
      this.truncated = true;
      return;
    }
    if (chunk.byteLength > remaining) {
      this.#chunks.push(chunk.subarray(0, remaining));
      this.#bytes = this.#maxBytes;
      this.truncated = true;
      return;
    }
    this.#chunks.push(chunk);
    this.#bytes += chunk.byteLength;
  }

  read(): string {
    // write() withholds an incomplete trailing sequence (the cap can cut one
    // mid-character); end() flushes it only for untruncated output, where a
    // partial sequence means the source itself emitted invalid UTF-8.
    const decoder = new StringDecoder('utf8');
    const text = decoder.write(Buffer.concat(this.#chunks));
    return this.truncated ? text : text + decoder.end();
  }
}
